import React, { useEffect } from 'react';
import '../../styles/ProfileModal.css';

function ProfileModal({ profile, onClose }) {
  // Close modal on ESC key press
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);

    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [onClose]);

  return (
    <div className='modal-overlay' onClick={onClose}>
      <div className='modal-content' onClick={(e) => e.stopPropagation()}>
        <button className='modal-close-button' onClick={onClose}>
          &times;
        </button>

        <div className='modal-profile-header'>
          <div className='modal-profile-photo-container'>
            {profile.photo ? (
              <img src={profile.photo} alt={profile.name} className='modal-profile-photo' />
            ) : (
              <div className='modal-profile-photo-placeholder'>
                <span>{profile.name.split(' ').map(n => n[0]).join('')}</span>
              </div>
            )}
          </div>
          <h2 className='modal-profile-name'>{profile.name}</h2>
          <p className='modal-profile-title'>{profile.modalTitle || profile.title}</p>
        </div>

        <div className='modal-profile-description'>
          {profile.logo ? (
            <>
              <p>{profile.description.split('Award-Winning Excellence:')[0]}</p>
              <p>Award-Winning Excellence:</p>
              <p>{profile.description.split('Award-Winning Excellence:')[1].split('Unmatched Client Trust:')[0]}</p>
              <div className='modal-logo-container'>
                <img src={profile.logo} alt={`${profile.name} certification`} className='modal-logo' />
              </div>
              <p>Unmatched Client Trust:{profile.description.split('Unmatched Client Trust:')[1]}</p>
            </>
          ) : (
            <p>{profile.description}</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProfileModal;
